import LLMsInstallationPlatforms from "../../../../contents/docs/llm-analytics/_snippets/llms-installation-platforms";
import * as React from 'react';
export default {
  LLMsInstallationPlatforms,
  React
};